import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface SectionHeadingProps {
  title: React.ReactNode;
  description?: string;
  link?: {
    to: string;
    label: string;
  };
  id?: string;
}
export function SectionHeading({
  title,
  description,
  link,
  id
}: SectionHeadingProps) {
  return <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between" data-id="element-629" data-mp="rwzreei586ry">
      <div className="max-w-2xl" data-id="element-630" data-mp="n099dlms313w">
        <h2 id={id} className="font-display text-4xl leading-[1.02] md:text-5xl" data-id="element-631" data-mp="n0hq5om0uqkd">
          {title}
        </h2>
        {description && <p className="mt-3 text-base text-muted" data-id="element-632" data-mp="d8bxecny4544">{description}</p>}
      </div>
      {link && <Link to={link.to} className="group inline-flex shrink-0 items-center gap-2 text-sm font-medium" data-id="element-633" data-mp="8aadjpip41rl">
          <span className="border-b border-ink/30 pb-0.5 transition-colors duration-150 group-hover:border-ink" data-id="element-634" data-mp="47nizgun42qp">
            {link.label}
          </span>
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-635" data-mp="1e0swdxh7xd67" />
        </Link>}
    </div>;
}